import { Component, Input } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-action-card',
  standalone: true,
  imports: [MatIconModule, MatRippleModule],
  templateUrl: './action-card.component.html',
  styleUrl: './action-card.component.css',
  host: {
    '[class.action-card-host--interactive]': 'interactive',
    '[class.action-card-host--disabled]': 'disabled',
    '[class.action-card-host--selected]': 'selected',
    '[attr.aria-disabled]': 'disabled ? true : null',
  },
})
export class ActionCardComponent {
  @Input() public title: string = '';
  @Input() public subTitle: string = '';
  @Input() public description: string = '';
  @Input() public icon: string = '';
  @Input() public interactive: boolean = false;
  @Input() public selected: boolean = false;
  @Input() public disabled: boolean = false;
}
